const PREFIX = "ai-employee-draft-v1:";

export function aiDraftKey(accountId: string | undefined, scope: string): string | null {
  return accountId ? `${PREFIX}${encodeURIComponent(accountId)}:${encodeURIComponent(scope)}` : null;
}

export function readAiDraft<T>(key: string | null): T | null {
  if (!key) return null;
  try {
    const item = JSON.parse(sessionStorage.getItem(key) || "null");
    if (!item || item.version !== 1 || typeof item.savedAt !== "number" || Date.now() - item.savedAt > 86400000 || !item.value || typeof item.value !== "object") return null;
    return item.value as T;
  } catch { return null; }
}

export function saveAiDraft(key: string | null, value: unknown) {
  if (!key) return;
  try { sessionStorage.setItem(key, JSON.stringify({version: 1, savedAt: Date.now(), value})); } catch { /* Storage failure must not prevent editing or applying. */ }
}

export function removeAiDraft(key: string | null) {
  if (key) try { sessionStorage.removeItem(key); } catch { /* Storage may be disabled. */ }
}

export function clearAiDrafts() {
  try {
    for (const key of Object.keys(sessionStorage)) if (key.startsWith(PREFIX)) sessionStorage.removeItem(key);
  } catch { /* Storage may be disabled. */ }
}
